import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var assetServices = {
  ASSET: 'asset',
  BACKGROUND: 'background',
  BAZAARVOICE: 'bazaarvoice',
  BUNDLE: 'bundle',
  EXT: 'ext',
  FACEBOOK: 'facebook',
  FILE: 'file',
  FLICKR: 'flickr',
  GOOGLEPLUS: 'googleplus',
  INSTAGRAM: 'instagram',
  LINKEDIN: 'linkedin',
  LITHIUM: 'lithium',
  MUX: 'mux',
  NEWSCRED: 'newscred',
  PINTEREST: 'pinterest',
  STATIC: 'static',
  TWITTER: 'twitter',
  UGC: 'ugc',
  UGCX: 'ugcx',
  VIMEO: 'vimeo',
  VINE: 'vine',
  VK: 'vk',
  WEB_URL: 'weburl',
  YOUTUBE: 'youtube',
  PEXELS: 'pexels'
};
assetServices.ALL = _valuesInstanceProperty(_).call(_, assetServices);
export default assetServices;
//# sourceMappingURL=asset-services.js.map